import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'
import useModelsFingerprint from '@/services/api/model/useModelsFingerprint'

/**
 * GET /team/cash-flow/status — "am I OK?" across the requested horizon.
 * Same o/c/p params as the chart/forecast-score. Ignores the dashboard vault
 * filter server-side — this hook doesn't send one.
 */
export default function useGetStatus({
  offset,
  numberOfPeriods,
  periodType,
  enabled = true,
} = {}) {
  const modelsFingerprint = useModelsFingerprint()

  const fetchData = async () => {
    const response = await httpClient.get('team/cash-flow/status', {
      params: { o: offset, c: numberOfPeriods, p: periodType },
    })
    return response.data
  }

  return useQuery({
    queryKey: [
      'status',
      { offset, numberOfPeriods, periodType, modelsFingerprint },
    ],
    queryFn: fetchData,
    staleTime: Infinity,
    enabled,
  })
}
